import { render, staticRenderFns } from "./ChatActionForm.vue?vue&type=template&id=53e05828&scoped=true&lang=pug&"
import script from "./ChatActionForm.vue?vue&type=script&lang=ts&"
export * from "./ChatActionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChatActionForm.vue?vue&type=style&index=0&id=53e05828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e05828",
  null
  
)

export default component.exports